import { createContext } from 'react';
export const QuestionFormContext = createContext({
    dispatch: () => { },
});

export const QuestionImageFormContext = createContext({
    dispatch: () => { },
});
